// extracted by mini-css-extract-plugin
module.exports = {"Container":"ScreenLoader_Container__1FUhx","Inner":"ScreenLoader_Inner__2J72p","loading":"ScreenLoader_loading__3bFJL"};